import { parseOpsDealId } from "./serviceJobKind";

export type OpsDealPick = { id: string; label: string };

export function opsDealPickFromUnknown(row: unknown): OpsDealPick | null {
  if (!row || typeof row !== "object") return null;
  const r = row as Record<string, unknown>;
  const id = parseOpsDealId(typeof r.id === "string" ? r.id : "");
  if (!id) return null;
  const name = typeof r.display_name === "string" ? r.display_name.trim() : "";
  return { id, label: name || `${id.slice(0, 8)}…` };
}

export function opsDealPicksFromList(rows: unknown): OpsDealPick[] {
  if (!Array.isArray(rows)) return [];
  return rows.map(opsDealPickFromUnknown).filter((x): x is OpsDealPick => Boolean(x));
}

export function filterOpsDealPicks(deals: readonly OpsDealPick[], q: string): OpsDealPick[] {
  const term = q.trim().toLowerCase();
  const matched = term
    ? deals.filter((d) => d.label.toLowerCase().includes(term) || d.id.toLowerCase().includes(term))
    : [...deals];
  return matched.slice(0, 8);
}
